import React, { useState } from "react";
import NotificationIcon from "../../components/common/NotificationIcon";
import NotificationSidebar from "../../components/common/NotificationSidebar";
import { useAuth } from "../../zustand/auth.store";
import SideDrawer from "../../components/Drawer/Sidebar";

const _extractInitials = (val: string) => {
  const _first = val?.split(" ")[0].slice(0, 1);
  const _second = val?.split(" ")[1].slice(0, 1);
  return `${_first?.toLocaleUpperCase()}${_second?.toLocaleUpperCase()}`;
};

const DashboardHeader = () => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false)

  const userProfile = useAuth.getState().profile as any





  const _openNav = () => {
    setIsNotificationOpen(true);
  };
  return (
    <header className="h-20 w-full sticky top-0 bg-white shadow-sm z-50 overflow-hidden">
      <div className="px-6 h-full flex justify-between items-center">
        <div className="h-auto w-auto">
          <SideDrawer />
        </div>
        <div className="flex items-center">
          {/* <div className="px-6 flex border-r items-center border-gray-400">
            <img src="" className="w-5 cursor-pointer mr-7" alt="" />
            <div className="px-6 flex font-normal inactive-nav items-center cursor:pointer">
              <img src="" className="w-5 cursor-pointer mr-4" alt="" />
            </div>
          </div> */}

          <div className="flex items-center px-6">
            <div className="text- hidden md:block ">{userProfile?.memberId || userProfile?.agent?.user?.memberId || "---"}</div>
            <div className="text- mx-4 hidden md:block ">{userProfile?.name || userProfile?.agent?.user?.fullName || "Test user"}</div>
            <NotificationSidebar
              setIsNotificationOpen={setIsNotificationOpen}
              isNotificationOpen={isNotificationOpen}
            />
            {/* <div
              onClick={() => {}}
              className={`w-10 h-10 rounded-full bg-opacity-20 cursor-pointer ${isNotificationOpen ? "bg-pc-lightblue" : "bg-transparent"
                } flex justify-center items-center`}
            >
              <div className="relative p-2 mr-3 mt-1">
                <span className="w-3 h-3 absolute bg-red-400 rounded-full z-10 top-1 right-[0.45rem] "></span>
                <NotificationIcon fill="#0066FF" />
              </div>
            </div> */}
            <span className="w-10 h-10 rounded-full flex items-center justify-center bg-pc-lightblue">
              <p className="text-white text-2xl font-medium">
                {_extractInitials(userProfile?.name || userProfile?.agent?.user?.fullName)}
              </p>
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
